module.exports = __webpack_public_path__ + "img/accounting.8d1a2a43.png";